import type { ProteinStructure } from '@/adapters/biology/_contract/proteinStructure';
import type { CosmosDataModel, RuntimeState } from '@/adapters/biology/_contract/config';

/** The structure matching the selected id, or the last shown structure while the selection is still loading. */
export function activeProteinStructure(
    runtimeState: RuntimeState,
    cosmosData: CosmosDataModel,
): ProteinStructure | undefined {
    const loaded = runtimeState.loadedStructure?.structure;
    const bundled = cosmosData.proteinStructure;
    if (loaded?.id === runtimeState.structureId) return loaded;
    if (bundled?.id === runtimeState.structureId) return bundled;
    return loaded ?? bundled;
}
